const $document = $(document),
  $window = $(window),
  $htmlBody = $('html, body'),
  $html = $('html'),
  $body = $('body'),
  $main = $('main'),
  $footer = $('footer'),
  $navmenuHeight = $('.nav-menu .col-12').outerHeight(true),
  iconListHeight =
    $('.icon-list').length === 0 ? 0 : $('.icon-list').outerHeight(true)

export {
  $document,
  $window,
  $htmlBody,
  $html,
  $body,
  $main,
  $footer,
  $navmenuHeight,
  iconListHeight
}
